import React, { useState } from 'react';
import './mobile-eval-list-admin.styles.scss';
import { properCase } from '../../../utils/properCase';
import { format } from 'date-fns';
import { faEllipsisH } from '@fortawesome/free-solid-svg-icons';
import ManageEvalsDropdown from './manage-evals-dropdown.component';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const MobileEvalListAdmin = ({
  evalsToDisplay,
  countLimit,
}) => {

  const [ showEvalDropdown, setShowEvalDropdown ] = useState(false);

  return (
    <div className='mobile-eval-list-admin'>
      <div className="g-space-1"></div>
      <table className='uk-table uk-table-striped'>
        <tbody>
          {
            (evalsToDisplay && evalsToDisplay.length > 0) &&
            evalsToDisplay
              .sort((a, b) => (a.title.toLowerCase() > b.title.toLowerCase()) ? 1 : -1)
              .slice(0, countLimit)
              .map(ev => (
                <tr key={ev.id}>
                  <td>
                    <div className='title'>
                      <b>{ev.title}</b>
                      <div className='dropdown-container'>
                        <div className='buttons'>
                          <button
                            className='g-button med-btn'
                            onClick={() => setShowEvalDropdown((showEvalDropdown === ev.id) ? null : ev.id)}>
                            <FontAwesomeIcon icon={faEllipsisH} />
                          </button>
                        </div>
                        <ManageEvalsDropdown
                          ev={ev}
                          showEvalDropdown={showEvalDropdown}
                          setShowEvalDropdown={setShowEvalDropdown} />
                      </div>
                    </div>
                    <div className="g-space-0-5"></div>
                    <div className='meta'>
                      Created: {format(new Date(ev.ts), "P")}
                    </div>
                    <div className='meta'>
                      Source: {properCase(ev.source)}
                    </div>
                    <div className='meta'>
                      {ev.path}
                    </div>
                  </td>
                </tr>
              ))
          }
        </tbody>
      </table>
    </div>
  )
}

export default MobileEvalListAdmin